<!-- Nav Start-->
<header class="app2 loding-header nav-abs custom-scroll">
  <!-- <div class="animated-bg"><i></i><i></i><i></i></div> -->
  <div class="container">
    <div class="row">
      <div class="col">
        <nav>
          <a href="#" class="d-inline-block m-r-auto">
            <i>
              <img
                src="assets/images/logo/fishmate_transparent.png"
                alt=""
                class="img-fluid"
              />
            </i>
          </a>
          <app-menu></app-menu>
        </nav>
      </div>
    </div>
  </div>
</header>
<!-- Nav end-->
